// extracted by mini-css-extract-plugin
export default {"modal":"NP-z","modalOverlay":"OP-z","outfitHeading":"PP-z"};